import React from "react";
import { useState, useEffect , useContext } from 'react';
import ChartComponent from '../../../../components/chart';
import { Spin } from 'antd';
import Api from "../../../../services/api";
import {getBarSize, getColor, getDates} from '../../../../utility';
import { toast } from 'react-toastify';
import ReChartComponent from "../../../../components/chartNew";

const AppNetworkComponent = (props) => {
  const [loading,setLoading] = useState(false);
	const [appNetworkCost,setAppNetworkCost] = useState([]);
  const [appNetworkCostData,setAppNetworkCostData] = useState({
  	labels : [],
  	datasets : []
  });
	// const appNetworkOptions = {
  //   indexAxis: 'y',
  //   elements: {
  //     bar: {
  //       borderWidth: 2,
  //     }
  //   },
  //   plugins: {
  //     legend: {
  //       display: false,
  //     },
  //     title: {
  //       display: true,
  //       position : "bottom",
  //       text: ''
  //     }
  //   }
  // };

  const appNetworkOptions = {
    indexAxis: 'y',
    legend: false
  };

	useEffect(() => {
    setLoading(true)
    Api.get(`api/overview/cost_by_network?os=${props.os}&from=${props.startDate.format('YYYY-MM-DD')}&to=${props.endDate.format('YYYY-MM-DD')}&code=${props.code}&country=${props.country}&ad_network=${props.adnetwork}&campaign=${props.campaign}&index_filter=${props.filter}`)
    .then(result => {
      if(result?.data?.code === 0){
        setAppNetworkCost(result.data.data)
        setLoading(false)
      }
    });
  }, [props.reload, props.filter]);

  useEffect(() => {

    let labels = [];
    let datasets = [{
      label: `${props.startDate.format('YYYY-MM-DD')} - ${props.endDate.format('YYYY-MM-DD')}`,
      data: [],
      backgroundColor: [],
      barThickness : getBarSize
    }];
    
  	appNetworkCost.map((i,k) => {
  		labels.push(i.name)
        datasets[0].data.push(i.value)
        datasets[0].backgroundColor.push(getColor(k))
  	})

  	setAppNetworkCostData({labels,datasets})
  }, [appNetworkCost]);

  return (
    <Spin spinning={loading}>
      {/* <ChartComponent type="bar" data={appNetworkCostData} options={appNetworkOptions} /> */}
      <ReChartComponent type="bar" data={appNetworkCostData} options={appNetworkOptions} />
    </Spin>
  )
}
export default AppNetworkComponent;